import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const BagIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M15.74 6.5V5.06c-.05-1.94-1.8-3.6-3.73-3.56-1.27 0-2.52.68-3.18 1.77-.65.96-.58 2.12-.57 3.23H1.5v16h21v-16h-6.76ZM9.27 5.11c.07-2.63 3.72-3.58 5.06-1.31.53.82.42 1.75.41 2.7H9.26V5.11h.01ZM21.5 21.5h-19v-14h19v14Z" />
  </IconWrapper>
)

export default BagIconMedium
